import Header from '@/pages/home/components/Header';
import HeroSection from '@/pages/home/components/HeroSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import CommentsSection from '@/pages/home/components/CommentsSection';
import RankingSection from '@/pages/home/components/RankingSection';
import CardsSection from '@/pages/home/components/CardsSection';
import CarouselSection from '@/pages/home/components/CarouselSection';
import ContactSection from '@/pages/home/components/ContactSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import AboutSection from '@/pages/home/components/AboutSection';
import IndexSection from '@/pages/home/components/IndexSection';
import FAQSection from '@/pages/home/components/FAQSection';
import TopicsSection from '@/pages/home/components/TopicsSection';
import MediaSection from '@/pages/home/components/MediaSection';
import AppSection from '@/pages/home/components/AppSection';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <FeaturesSection />
        <CommentsSection />
        <RankingSection />
        <CardsSection />
        <CarouselSection />
        <ContactSection />
        <UpdatesSection />
        <AboutSection />
        <IndexSection />
        <FAQSection />
        <TopicsSection />
        <MediaSection />
        <AppSection />
      </main>
      <Footer />
    </>
  );
}